import { type JSONData } from "../../base_classes/dto.d";
import { AirlineOrderDto } from "./dto.gen";
import { type IAirlineOrder } from "./entity.d";
import AirlineOrderParsers from "./parsers";
import AirlineOrderValidators from "./custom_validators";
import request from "@/data/api/request";

export class AirlineOrder extends AirlineOrderDto implements IAirlineOrder {
  constructor(
    pathVars?:
      | string
      | string[]
      | {
          id?: string;
        },
    data?: JSONData,
  ) {
    super(data, AirlineOrderParsers, AirlineOrderValidators);

    if (data !== undefined) {
      // Set data
      this.set(data);
    }

    this.buildPathObject(pathVars);
  }
  /// ///////////////////////////////////////
  /// //////// PRIVATE VARIABLES ////////////
  /// ///////////////////////////////////////

  /// ///////////////////////////////////////
  /// ///////// PUBLIC VARIABLES ////////////
  /// ///////////////////////////////////////

  /// ///////////////////////////////////////
  /// ////////////// METHODS ////////////////
  /// ///////////////////////////////////////

  public async get(
    pathVars?:
      | string
      | string[]
      | {
          id?: string;
        }
      | undefined,
  ): Promise<AirlineOrder> {
    return (await super.get(pathVars)) as AirlineOrder;
  }

  /// ///////////////////////////////////////
  /// /////////// STATIC METHODS ////////////
  /// ///////////////////////////////////////

  static override FromJSON(data?: JSONData): AirlineOrder {
    return new AirlineOrder(undefined, data);
  }

  static override FromJSONArray(data: JSONData[]): AirlineOrder[] {
    return data.map((item) => AirlineOrder.FromJSON(item));
  }

  static FromDto(dto: AirlineOrderDto): AirlineOrder {
    return new AirlineOrder(undefined, dto.toJSON());
  }

  /**
   * Sanitize the orders to be processed
   * @param partialOrders The given (partial) orders
   * @returns {AirlineOrder[]} The sanitized orders
   */
  static selectOrderAndIdsByDeliveryAddressCode(
    orders: AirlineOrder[],
    deliveryAddressCode: number,
  ): { orders: AirlineOrder[]; orderIds: string[] } {
    orders = orders.filter(
      (order: any) =>
        (order.warehouse === "01" ? 1265 : parseInt(order.deliveryAddress)) ===
        deliveryAddressCode,
    );

    const orderIds = orders.map((order: any) => order.id);

    return {
      orders,
      orderIds,
    };
  }

  static async SyncExternalAirlineOrders(): Promise<void> {
    await request({
      url: "external/airline_orders",
      method: "GET",
    });
  }
}
